export default "__VITE_ASSET__92251b77__"